/**
 * @param  {string<ServiceType>} serviceType
 * @param  {ErrorsHandler.handleError} handleError
 */
import pathOr from 'ramda/src/pathOr';

import ErrorType from '../../../Errors/Constants/Error.type';
import ErrorPayload from '../../../Errors/Utils/ErrorPayload';

const handlePlaybackServiceError = handleError =>
    error => {
        let type;
        const API_ERROR_CODE_GENERIC = '10000';
        const apiErrorCode = pathOr(API_ERROR_CODE_GENERIC, ['response', 'data', 'odata.error', 'code'], error);

        switch (apiErrorCode.toString()) {
            case '10008':
                type = ErrorType.API_SERVICE_PLAYBACK_CONCURRENT_USER_LIMIT;
                break;
            case '10006':
            case '10013':
                type = ErrorType.API_SERVICE_PLAYBACK_RESTRICTED_LOCATION;
                break;
            case '10000':
            default:
                type = ErrorType.API_SERVICE_PLAYBACK;
                break;
        }

        handleError(new ErrorPayload(type, error));
    };

export default handlePlaybackServiceError;
